import React from "react";
import { INSTALLMENTS_DURATION_CHOICE } from "repoV2/features/Payments/Payments.constants";
import { IInstallments } from "repoV2/features/Payments/Payments.interface";
import { pluralise } from "repoV2/features/Common/utils/strings";
import {
    formatNumberWithCommas,
    roundOff,
} from "repoV2/features/Common/utils/numbers";
import { classNames } from "repoV2/utils/common/render/classNames";
import styles from "./Installment.module.scss";

const getPartPaymentSubtext = (
    paymentDuration: number,
    paymentDurationChoice: number
) => {
    const suffix = {
        [INSTALLMENTS_DURATION_CHOICE.DAYS]: "day",
        [INSTALLMENTS_DURATION_CHOICE.WEEKS]: "week",
        [INSTALLMENTS_DURATION_CHOICE.MONTHS]: "month",
    };

    return `${paymentDuration} ${pluralise(
        suffix?.[paymentDurationChoice],
        paymentDuration
    )} from purchase`;
};

const Installment = (props: {
    installment: IInstallments;
    currency: string;
    currencyLocale: string;
    isFirstInstallment: boolean;
}) => {
    const { installment, currency, currencyLocale, isFirstInstallment } = props;

    const {
        installment_price_final: installmentPrice,
        payment_duration: paymentDuration = 1,
        payment_duration_choice: paymentDurationChoice,
        discount_applied: discountPriceToDeduct = 0,
    } = installment;

    const actualInstallmentPrice = installmentPrice - discountPriceToDeduct;

    return (
        <div className={styles.root}>
            <div className={styles.bullet}>
                <div className={classNames(styles.dot)} />
                <div className={styles.bar} />
            </div>

            <div className={styles.infoContainer}>
                <div className={styles.priceContainer}>
                    {discountPriceToDeduct > 0 && (
                        <del
                            className={styles.strikeOffPrice}
                        >{`${currency}${formatNumberWithCommas({
                            num: roundOff(installmentPrice, 2),
                            locale: currencyLocale,
                        })}`}</del>
                    )}
                    <div
                        className={styles.actualPrice}
                    >{`${currency}${formatNumberWithCommas({
                        num: roundOff(actualInstallmentPrice, 2),
                        locale: currencyLocale,
                    })}`}</div>
                </div>
                <div className={styles.priceSubTextStyle}>
                    {isFirstInstallment
                        ? "To pay now"
                        : getPartPaymentSubtext(
                              paymentDuration,
                              paymentDurationChoice
                          )}
                </div>
            </div>
        </div>
    );
};

export default Installment;
